import React from 'react';

//Hooks
import {useSelector} from "react-redux";

//Components
import {Col as RBCol} from 'react-bootstrap';

const Col = React.forwardRef(({children, ...props}, ref) => {
    const style = useSelector(state => state.widget.style);

    if(style === 'side') {
        return (
            <RBCol ref={ref} bsPrefix={props.bsPrefix} className={props.className} as={props.as} xs={12}>
                {children}
            </RBCol>
        );
    }

    return (
        <RBCol ref={ref} {...props}>
            {children}
        </RBCol>
    );
});

export default Col